import React, { Fragment, PropsWithChildren } from "react";
import Skeleton, { SkeletonProps } from "../Skeleton/Skeleton";

interface SkeletonListProps {
  noOfItems: number;
  skeletonProps?: SkeletonProps;
}

function SkeletonList({
  noOfItems,
  skeletonProps,
  children,
}: PropsWithChildren<SkeletonListProps>) {
  return (
    <>
      {Array.from({ length: noOfItems }).map((_, index) => (
        <Fragment key={index}>
          {children ?? <Skeleton key={index} {...skeletonProps} />}
        </Fragment>
      ))}
    </>
  );
}

export default SkeletonList;
